import { FC } from "react"
import { RtkHookForm } from "@/core/components/form/rtkHookForm"
import { UpdateChannelDto, IUpdateChannelRes } from "../../interface/interface"
import { useUpdateChannelMutation } from "../../services/channels/channelsApi"
import { Stack } from "@mui/material"
import { TextFieldElement, CheckboxElement } from "react-hook-form-mui"

interface IProps {
  channelId: string
  initialValues?: Partial<UpdateChannelDto>
  onSuccess?: () => void
}

interface IFormData extends UpdateChannelDto {
  id: string
}

export const EditChannelForm: FC<IProps> = ({
  channelId,
  initialValues,
  onSuccess,
}) => {
  return (
    <RtkHookForm<IFormData, IUpdateChannelRes, typeof useUpdateChannelMutation>
      successMessage="Канал обновлен успешно"
      mutationHook={useUpdateChannelMutation}
      formContextParams={{
        defaultValues: {
          id: channelId,
          is_hidden: initialValues?.is_hidden || false,
          custom_name: initialValues?.custom_name || "",
          comment: initialValues?.comment || "",
        },
      }}
      getSubmitHandlerParams={(data: IFormData) => ({
        pathParams: { id: data.id },
        body: {
          is_hidden: data.is_hidden,
          custom_name: data.custom_name || undefined,
          comment: data.comment || undefined,
        },
      })}
      afterSubmit={onSuccess}
      actions={[
        {
          text: "Сохранить",
          type: "submit",
          variant: "contained",
          fullWidth: true,
        },
      ]}
    >
      <Stack spacing={2}>
        <TextFieldElement
          name="custom_name"
          label="Пользовательское имя"
          fullWidth
        />
        <TextFieldElement
          name="comment"
          label="Комментарий"
          fullWidth
          multiline
          rows={3}
        />
        <CheckboxElement name="is_hidden" label="Скрыть канал" />
      </Stack>
    </RtkHookForm>
  )
}
